module.exports = __webpack_public_path__ + "img/renewal-icon.7eb47055.png";